const stats = [
  { value: "12", unit: "章", label: "完整剧情章节", icon: "ri-film-line" },
  { value: "158", unit: "分钟", label: "影片总时长", icon: "ri-time-line" },
  { value: "3", unit: "个", label: "深度专题方向", icon: "ri-book-open-line" },
  { value: "6", unit: "部", label: "同类型推荐", icon: "ri-movie-2-line" },
];

export default function StatsStrip() {
  return (
    <section className="border-y border-background-200 bg-background-100">
      <div className="container-page grid grid-cols-2 divide-background-200 lg:grid-cols-4 lg:divide-x">
        {stats.map((stat) => (
          <div key={stat.label} className="flex items-center gap-3 py-6 lg:justify-center lg:py-8">
            <span className="flex h-10 w-10 items-center justify-center rounded-md border border-accent-500/30 bg-accent-500/10 text-accent-400">
              <i className={`${stat.icon} text-lg leading-none`} />
            </span>
            <div>
              <p className="font-heading text-xl leading-none text-foreground-950">
                {stat.value}
                <span className="ml-1 font-label text-xs text-foreground-500">{stat.unit}</span>
              </p>
              <p className="mt-1.5 font-label text-[11px] tracking-wide text-foreground-600">{stat.label}</p>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}